import { ModuleWithProviders, NgModule } from '@angular/core';
import { HttpClient, HttpClientModule } from '@angular/common/http';
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { StoreModule } from '@ngrx/store';
import { reducers } from './consent.store';
import { EffectsModule } from '@ngrx/effects';
import { ConsentComponent } from './components/consent/consent.component';
import { EnableConsentEffects } from './effects/enable-consent.effects';
import { DisableConsentEffects } from './effects/disable-consent.effects';
import { ConfigModule } from '../config/config.module';
import { UrlParamsModule } from '../url-params/url-params.module';
import { ConsentEffects } from './effects/consent.effects';
import { ConsentRestClient } from './services/consent-rest-client.service';
import { createTranslateLoader } from '../../core/core.module';
import { CommonModule } from '@angular/common';
import { SharedModule } from '../shared/shared.module';
import { EnableConsentAuthDialogComponent } from './components/enable-consent-auth-dialog/enable-consent-auth-dialog.component';
import { TooltipModule } from 'ngx-bootstrap';

@NgModule({
    imports: [
        CommonModule,
        SharedModule,
        TooltipModule,
        TranslateModule.forChild({
            loader: {
                provide: TranslateLoader,
                useFactory: (createTranslateLoader),
                deps: [HttpClient]
            }
        }),
        ConfigModule,
        UrlParamsModule,
        HttpClientModule,
        StoreModule.forFeature('consent', reducers),
        EffectsModule.forFeature([ConsentEffects, EnableConsentEffects, DisableConsentEffects])
    ],
    declarations: [ConsentComponent, EnableConsentAuthDialogComponent],
    exports: [ConsentComponent, EnableConsentAuthDialogComponent],
    entryComponents: [EnableConsentAuthDialogComponent]
})
export class ConsentModule {
    static forRoot(): ModuleWithProviders {
        return {
            ngModule: ConsentModule,
            providers: [ConsentRestClient]
        };
    }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/angular-router-loader/src!./~/tslint-loader!./src/app/modules/consent/consent.module.ts